export const createElementScrollStrategy = (messagesContainerRef, messagesRef) => ({
  getContainerElement() {
    return messagesContainerRef.current;
  },

  getMessagesElement() {
    return messagesRef.current;
  },

  resetScroll() {
    this.getMessagesElement()?.style.removeProperty('min-height');
  },

  setMinHeight(lastUserMessageElement) {
    const containerElement = this.getContainerElement();
    const messagesElement = this.getMessagesElement();

    if (!containerElement || !messagesElement || !lastUserMessageElement) {
      return;
    }

    messagesElement.style.minHeight = `${containerElement.clientHeight + lastUserMessageElement.offsetTop}px`;
  },

  scrollToElement(lastUserMessageElement) {
    const containerElement = this.getContainerElement();

    if (!lastUserMessageElement || !containerElement) {
      return;
    }

    requestAnimationFrame(() => {
      this.setMinHeight(lastUserMessageElement);

      const smoothScroll =
        lastUserMessageElement.offsetTop - containerElement.scrollTop < containerElement.clientHeight * 1.5;

      containerElement.scrollTo({
        top: lastUserMessageElement.offsetTop,
        behavior: smoothScroll ? 'smooth' : undefined,
      });
    });
  },
});
